import React, { Fragment } from 'react'

const BkFlowPolicyViewerTabs = props => {
  const {
    policies,
    currentPolicy,
    policyEvent
  } = props

  let renderTabs = []

  for (const policyKey in policies)  {
    let policyName = policies[policyKey].name ? policies[policyKey].name : policies[policyKey].title;
    if (policyName) {
      renderTabs.push(
        <div
          key={ policyKey }
          className={ policyKey === currentPolicy ? 'bk-flow__policy-viewer-tab active' : 'bk-flow__policy-viewer-tab' }
          onClick={ () => policyEvent(policyKey) }
        >
          { policyName }

          { policyKey === currentPolicy ?
            <Fragment>
              <i className="material-icons desktop">arrow_right</i>
              <i className="material-icons mobile">remove</i>
            </Fragment>
            :
            <Fragment>
              <i className="material-icons mobile">add</i>
            </Fragment>
          }

        </div>
      )
    }
  }

  return (
    <div className="bk-flow__policy-viewer-tabs">
      { renderTabs }
    </div>
  )
}

export default BkFlowPolicyViewerTabs



// WEBPACK FOOTER //
// ./src/components/policies/elements/BkFlowPolicyViewerTabs.js